import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=5f3903ab&scoped=true&"
import script from "./LabelSelector.vue?vue&type=script&lang=js&"
export * from "./LabelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=5f3903ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3903ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3903ab')) {
      api.createRecord('5f3903ab', component.options)
    } else {
      api.reload('5f3903ab', component.options)
    }
    module.hot.accept("./LabelSelector.vue?vue&type=template&id=5f3903ab&scoped=true&", function () {
      api.rerender('5f3903ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/LabelSelector.vue"
export default component.exports